export const genTranslationChunksConfig = {
    autoShip: ['autoShip'],
    contactFactory: ['contactFactory'],
    limitedAvailability: ['limitedAvailability'],
    shippingAccounts: ['shippingAccounts'],
    savedAddress: ['savedAddress'],
    spSearch: ['spSearchDialog']
}
